












































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import LockBackgroundV2 from '@/mixin/LockBackgroundV2'

const focusableElementSelector = [
  'a[href]',
  'button:not([disabled])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')
const titleIdRadix = 36
const titleIdRandomStringStartIndex = 2

@Component({
  mixins: [
    LockBackgroundV2,
  ],
})
export default class HalfModal extends Vue {
  @Prop({ default: 'ダイアログ' })
  accessibilityLabel: string

  $refs: {
    sheet: HTMLElement
  }

  titleId = `half-modal-title-${Math.random().toString(titleIdRadix).slice(titleIdRandomStringStartIndex)}`
  private previousActiveElement: Element | null = null

  mounted(): void {
    this.previousActiveElement = document.activeElement
    document.addEventListener('keydown', this.handleKeydown)

    this.$nextTick(() => {
      this.focusInitialElement()
    })
  }

  beforeDestroy(): void {
    document.removeEventListener('keydown', this.handleKeydown)
    this.restoreFocus()
  }

  private handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.$emit('close')

      return
    }

    if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  private focusInitialElement(): void {
    const sheet = this.sheetElement
    if (!sheet) {
      return
    }

    sheet.focus()
  }

  private trapFocus(event: KeyboardEvent): void {
    const sheet = this.sheetElement
    if (!sheet) {
      return
    }

    const focusableElements = this.focusableElements

    if (focusableElements.length === 0) {
      event.preventDefault()
      sheet.focus()

      return
    }

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (document.activeElement === sheet) {
      event.preventDefault()
      const nextElement = event.shiftKey ? lastElement : firstElement
      nextElement.focus()

      return
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault()
      lastElement.focus()

      return
    }

    if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault()
      firstElement.focus()
    }
  }

  private get focusableElements(): HTMLElement[] {
    const sheet = this.sheetElement
    if (!sheet) {
      return []
    }

    return Array.prototype.slice.call(
      sheet.querySelectorAll(focusableElementSelector)
    )
  }

  private get sheetElement(): HTMLElement | null {
    const sheet = this.$refs.sheet

    if (sheet instanceof HTMLElement) {
      return sheet
    }

    return null
  }

  private restoreFocus(): void {
    if (this.previousActiveElement instanceof HTMLElement) {
      this.previousActiveElement.focus()
    }
  }
}
